<ion-header [translucent]="true">
  <ion-toolbar class="toolbar-with-closing-button border-b !border-neutral-200 !px-2 md:!px-4">
    <div slot="end" class="hidden md:flex md:w-8"></div>
    <ion-title class="common-ion-title !text-md">
      {{ titleLabel() }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<div class="content-area">
  @for (filter of filters(); track filter.name; let first = $first) {
    <section class="filter-section" [ngClass]="{ 'border-t border-neutral-200': !first }">
      @if (hasMultipleSections()) {
        <h3 class="filter-section-title">{{ filter.label }}</h3>
      }
      <ng-container *ngTemplateOutlet="filter.template" />
    </section>
  }
</div>

<div class="footer">
  <button
    type="button"
    class="link-component !text-md font-semibold"
    [class.!text-disabled]="!isSelected()"
    [disabled]="!isSelected()"
    (click)="onClearAll()"
  >
    {{ clearAllLabelKey() | transloco }}
  </button>
</div>
